import { NVButton } from '@nv/basic-components'
import CirclePlusIcon from '@nv/images/design/circle-plus-icon'
import PencilIcon from '@nv/images/design/pencil-icon'
import TrashCanIcon from '@nv/images/design/trash-can-icon'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styles from './AdminCommunicationsTemplates.module.scss'

export const AdminCommunicationsTemplates = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div className={styles['container']}>
      <div className={styles['header']}>
        <h1>{t('Communications')}</h1>
        <NVButton variant='primaryGrey' text={t('New Template')} height={40} icon={<CirclePlusIcon />} />
      </div>

      <div className={styles['template']}>
        <span className={styles['tag']}>Email</span>
        <div className={styles['message']}>Rank choice voting open</div>
        <div className={styles['actions']}>
          <NVButton variant='iconOnly' onClick={null} icon={<TrashCanIcon />} />
          <NVButton variant='iconOnly' onClick={null} icon={<PencilIcon />} />
          <NVButton variant='action' text={t('Preview')} onClick={() => navigate('/admin/edit-communication/')} />
        </div>
      </div>
    </div>
  )
}
